<template>
    <div class="sharing"
        v-if="permissions.isAdmin">
        <div class="icon"
            @click="isVisible=!isVisible"
            tabindex="0">
            <Icon icon="more_vert"/>
        </div>
        <TransitionEffect name="simpleFade">
            <div :class="['overlay', alignment]"
                v-on-clickaway="closeOverlay"
                v-if="isVisible">
                <TextField class="field"
                    id="socialMediaImage"
                    v-model="socialMediaImage"
                    label="Social media image URL"/>
                <TextField
                    id="shareUrl"
                    v-model="shareUrl"
                    suffixIcon="content_copy"
                    @suffixIconAction="copyShareLink"
                    disabled
                    label="Social media share URL"/>
            </div>
        </TransitionEffect>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway'

    export default {
        name: 'DynamicLinkModule',
        mixins: [ clickaway ],
        props: {
            route: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            caption: {
                type: String,
                required: true
            },
            alignment: {
                type: String,
                default: 'right'
            }
        },
        data() {
            return {
                socialMediaImage: '',
                isVisible: false,
            }
        },
        computed: {
            shareUrl() {
                var link = 'https://theuniverse.page.link/?link=https://theuniverse.io/' + this.route + '/' + this.id + '&st=' + encodeURIComponent(this.title) + '&sd=' + encodeURIComponent(this.caption) + '&si=' + this.socialMediaImage
                
                let formattedLink = link.replace(/ /g,"%20")
                return formattedLink
            }
        },
        methods: {
            copyShareLink() {
                try {
                    navigator.clipboard.writeText(this.shareUrl)
                    this.$toasted.show(this.siteContent.copiedToClipBoard)
                } catch {
                    this.$toasted.show(this.siteContent.actionError)
                }
            },
            closeOverlay() {
                this.isVisible=false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .icon {
        position: relative;
        padding: 0.75rem;
        border-radius: 1rem;
        background: var(--color-grey-150);
        display: flex;
        width: fit-content;
        cursor: pointer;
        transition: $transition-eio-20;

        &:hover {
            background: var(--color-grey-200);
        }

        &:focus {
            outline: 0;
            box-shadow: var(--shadow-focus-s);
        }
    }

    .overlay {
        position: absolute;
        margin-top: 0.25rem;
        border-radius: 1rem;
        background: var(--color-grey-150);
        padding: 1rem;
        z-index: 1;
        box-shadow: var(--shadow-l);
        width: max-content;
    }

    .field {
        margin-bottom: 1rem;

        &:last-child {
            margin: 0;
        }
    }

    .left {
        right: 0;
    }
</style>